import { FC, SVGProps } from "react";


{/* eslint-disable max-len */}
const RiskModelIcon:FC<SVGProps<SVGSVGElement>> = (props):JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M8.07532 14.653C8.02667 14.6707 7.97331 14.6707 7.92466 14.653C7.27799 14.4263 2.66666 12.6263 2.66666 7.50097V2.86897C2.66652 2.80939 2.68633 2.75148 2.72295 2.70447C2.75956 2.65747 2.81086 2.62408 2.86866 2.60963L7.93532 1.34097C7.97778 1.33035 8.0222 1.33035 8.06466 1.34097L13.1313 2.60963C13.1891 2.62408 13.2404 2.65747 13.277 2.70447C13.3136 2.75148 13.3335 2.80939 13.3333 2.86897V7.50097C13.3333 12.6776 8.72266 14.4323 8.07532 14.6536V14.653Z" stroke="#232325" strokeWidth="1.2" strokeMiterlimit="10" strokeLinejoin="round"/>
  </svg>

);

export default RiskModelIcon;